import { render, staticRenderFns } from "./xskSkuP.vue?vue&type=template&id=d89cfabe&scoped=true"
import script from "./xskSkuP.vue?vue&type=script&lang=js"
export * from "./xskSkuP.vue?vue&type=script&lang=js"
import style0 from "./xskSkuP.vue?vue&type=style&index=0&id=d89cfabe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89cfabe",
  null
  
)

export default component.exports